import { initialApiState, ApiCallBase, apiClient } from '@/infrastructure/api'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
  setSelectedEcommerce,
  setSelectedGroup
} from '../features/general-data/general-data-slice'
import type { RootState } from '../store'
import { PbMeResponse, SettingsApi } from '@itsrever/rever-api'
import { toValidSelection } from '@/domain/store-group'

const settingsApi = new SettingsApi(undefined, undefined, apiClient)

interface GetMeCall extends ApiCallBase {
  response: PbMeResponse
}

interface State {
  getMe: GetMeCall
}

const initialState: State = {
  getMe: initialApiState
}

export const getMe = createAsyncThunk(
  '/getMe',
  async (_, { dispatch, getState }) => {
    const getMeResponse = await settingsApi.me()
    const { selectedEcommerce, selectedGroup } = (getState() as RootState)
      .generalData
    const next = toValidSelection(getMeResponse.data.user, {
      ecommerce: selectedEcommerce,
      group: selectedGroup
    })
    if (next.ecommerce !== selectedEcommerce || next.group !== selectedGroup) {
      dispatch(
        next.group
          ? setSelectedGroup(next.group)
          : setSelectedEcommerce(next.ecommerce)
      )
    }
    return getMeResponse.data
  }
)

const authApiSlice = createSlice({
  name: 'authApi',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMe.pending, (state) => {
      state.getMe.loading = 'pending'
    })
    builder.addCase(getMe.fulfilled, (state, action) => {
      state.getMe.loading = 'succeeded'
      const data: PbMeResponse = {
        ...action.payload,
        user: {
          ...action.payload.user,
          e_commerces_ids: action.payload.user?.e_commerces_ids?.sort((a, b) =>
            a.localeCompare(b, undefined, {
              sensitivity: 'base'
            })
          )
        }
      }
      state.getMe.response = data
    })
    builder.addCase(getMe.rejected, (state, action) => {
      state.getMe.loading = 'failed'
      state.getMe.error = action.error
    })
  }
})

export default authApiSlice.reducer
